import { BaseFont } from '../BaseFont';

class BaseRich extends BaseFont {

}

export {
  BaseRich,
};
